import { UserAppointmentModality } from '../types/api/beneficiaries.js';

export const APPOINTMENT_MODALITIES_LABELS: Record<UserAppointmentModality, string> = {
  [UserAppointmentModality.IN_PERSON]: 'En présentiel',
  [UserAppointmentModality.REMOTE]: 'À distance',
};

export const APPOINTMENT_MODALITIES_COLORS: Record<UserAppointmentModality, string> = {
  [UserAppointmentModality.IN_PERSON]: 'accent',
  [UserAppointmentModality.REMOTE]: 'primary',
};
